module.exports = __webpack_public_path__ + "static/bk-4-2235b63845bfb9db1c5b76036be8c609.png";